module.exports = __webpack_public_path__ + "img/bny-detail-4.3f6acb06.png";